import { Card, CardContent } from "@/components/ui/card";

import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

export function NoDataFound() {
  const { t } = useTranslation(["error"]);

  return (
    <Card className="border-blue-500 bg-blue-50 dark:bg-blue-950 text-blue-800 dark:text-blue-200">
      <CardContent className="p-4 flex items-center gap-3">
        <Info className="h-5 w-5 flex-shrink-0" />
        <div>
          <h3 className="font-semibold text-sm">{t("error:noData.title")}</h3>
          <p className="text-xs">{t("error:noData.description")}</p>
          <br />
          <p className="text-md">{t("error:noData.message")}</p>
        </div>
      </CardContent>
    </Card>
  );
}

export function ErrorFetchingData() {
  const { t } = useTranslation(["error"]);

  return (
    // This can suspend an ongoing data fetch retry
    <div className="min-h-screen bg-background p-10 lg:p-12">
      <div className="mx-auto">
        <Card className="p-6">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-destructive mb-2">
              {t("error:errorLoadingData.title")}
            </h2>
            <p className="text-muted-foreground">
              {t("error:errorLoadingData.description")}
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
}
